import { __ } from '@wordpress/i18n';

export default {
	message: __( 'Estate Slider', 'kam001-real-estate-blocks' ),
};
